module.exports = __webpack_public_path__ + "static/media/twins.168eedfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile-icons/twins.svg
// module id = 1116
// module chunks = 31